/* eslint-disable no-undef */
/* eslint-disable yoda */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter
} from '@ps-design-system/components/Dialog';
import { Button } from '@ps-design-system/components/Button';

import EndPauseModalHost from './EndPauseModalHost';
import EndPauseModalPS from './EndPauseModalPS';

import { usePauseModal } from '../context/PauseModalContext';
import { usePauseListingActions } from '../hooks/usePauseListingActions';
import { fetchListingInfo } from '../../../../app-main/actions/listing';

const EndPauseModal = () => {
  const [applyToAllListingsToggle, setApplyToAllListingsToggle] = useState(false);
  const {
    openEndPause,
    setEndPauseOpen,
    closeEndPauseModal,
    spaceID,
    listingID,
    listingsIDs,
    listingStatus,
    dispatch,
    SSOid
  } = usePauseModal();
  const [understandCheck, setUnderstandCheck] = useState(false);
  const { handleUnPauseListing, handleUnPauseListings } = usePauseListingActions();

  const resetState = () => {
    setApplyToAllListingsToggle(false);
    setUnderstandCheck(false);
  };

  const handleCancel = () => {
    resetState();
    closeEndPauseModal();
  };

  const handleOpenChange = (isOpen) => {
    setEndPauseOpen(isOpen);

    if (!isOpen) {
      resetState();
    }
  };

  const handleSubmit = async () => {
    let idsToTrack = [];
    try {
      if (applyToAllListingsToggle) {
        await handleUnPauseListings(spaceID);
        idsToTrack = [...listingsIDs];
      } else {
        await handleUnPauseListing(listingID);
        idsToTrack.push(listingID);
      }
      analytics.track('listing unpaused', {
        ssoId: SSOid,
        listingIds: idsToTrack
      });
    } catch (error) {
      // silently fail
    } finally {
      dispatch(fetchListingInfo(listingID));
    }
    resetState();
    closeEndPauseModal();
  };

  const renderContent = () => {
    if (listingStatus === 'PAUSED') {
      return (
        <EndPauseModalHost
          isToggled={applyToAllListingsToggle}
          handleToggle={setApplyToAllListingsToggle}
        />
      );
    }
    return (
      <EndPauseModalPS
        isToggled={applyToAllListingsToggle}
        handleToggle={setApplyToAllListingsToggle}
        isChecked={understandCheck}
        handleChecked={setUnderstandCheck}
      />
    );
  };

  return (
    <Dialog open={openEndPause} onOpenChange={handleOpenChange} >
      <DialogContent size="lg">
        <DialogHeader
          headerAlignment="left"
          showCloseButton
          className="pause-modal-step-one-container"
        >
          <DialogTitle className="pause-modal-dialog-header">
            <FormattedMessage id="pause.modal.activate_title" defaultMessage="Activate paused listing"/>
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="pause-step-one-body">
            {renderContent()}
          </div>
        </DialogBody>
        <DialogFooter className="pause-dialog-footer">
          <div className="footer-container">
            <div>
              <Button
                variant="underline"
                onClick={handleCancel}
                attributes={{ 'data-testing-id': 'pause-modal-cancel' }}
              >
                <FormattedMessage id="pause.modal.cancel" defaultMessage="Cancel"/>
              </Button>
            </div>
            <div className="footer-button">
              <Button
                appearance="purple"
                onClick={handleSubmit}
                attributes={{ 'data-testing-id': 'pause-modal-activate' }}
                disabled={!(understandCheck || listingStatus === 'PAUSED')}
              >
                <FormattedMessage id="pause.modal.activate_button" defaultMessage="Activate" />
              </Button>
            </div>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EndPauseModal;
